"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

require("../rce/languages/sv_SE");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  alternative_text_a834dcad: {
    message: "Alternativ text:"
  },
  announcement_list_da155734: {
    message: "Meddelandelista"
  },
  announcements_a4b8ed4a: {
    message: "Meddelanden"
  },
  assignments_1e02582c: {
    message: "Uppgifter"
  },
  background_color_press_down_to_select_ef99fdac: {
    message: "Bakgrundsf\xE4rg, tryck ner f\xF6r att v\xE4lja"
  },
  c_2001_acme_inc_283f7f80: {
    message: "(c) 2001 Acme Inc."
  },
  cancel_file_upload_9903e7b9: {
    message: "Avbryt filuppladdning"
  },
  cancel_image_upload_2c771950: {
    message: "Avbryt bilduppladdning"
  },
  cc_attribution_f6de631f: {
    message: "CC Attribut"
  },
  cc_attribution_no_derivatives_b006744f: {
    message: "CC Erk\xE4nner inga bearbetningar"
  },
  cc_attribution_non_commercial_39e0d30d: {
    message: "CC Attribut Ej Kommersiell"
  },
  cc_attribution_non_commercial_no_derivatives_9fe74c00: {
    message: "CC Attribut Ej Kommersiell Inga Derivat"
  },
  cc_attribution_non_commercial_share_alike_c7edb1e5: {
    message: "CC Attribut Ej Kommersiell Dela Lika"
  },
  cc_attribution_share_alike_669e7f16: {
    message: "CC Attribut Dela Lika"
  },
  check_if_the_image_is_decorative_283649b7: {
    message: "Kontrollera om bilden \xE4r dekorativ"
  },
  choose_usage_rights_33683854: {
    message: "\xC4ndra anv\xE4ndningsr\xE4ttigheter"
  },
  click_any_file_to_insert_a_download_link_for_that__a708fa4c: {
    message: "Klicka p\xE5 en fil f\xF6r att l\xE4gga till en nedladdningsl\xE4nk f\xF6r den filen."
  },
  click_any_image_to_embed_the_image_in_the_page_2cdd1136: {
    message: "Klicka p\xE5 en bild f\xF6r att b\xE4dda in bilden p\xE5 sidan."
  },
  click_any_page_to_insert_a_link_to_that_page_ac920c02: {
    message: "Klicka p\xE5 en sida f\xF6r att l\xE4gga till en l\xE4nk till sidan."
  },
  click_to_embed_image_33107dd8: {
    message: "Klicka f\xF6r att b\xE4dda in bild"
  },
  click_to_embed_imagename_c41ea8df: {
    message: "Klicka f\xF6r att b\xE4dda in { imageName }"
  },
  click_to_insert_a_link_into_the_editor_c19613aa: {
    message: "Klicka f\xF6r att infoga en l\xE4nk i redigeraren."
  },
  click_to_insert_a_link_to_this_item_39794098: {
    message: "Klicka f\xF6r att infoga en l\xE4nk till detta f\xF6rem\xE5l."
  },
  close_flickr_form_b32e600a: {
    message: "St\xE4ng Flickr formul\xE4ret"
  },
  collaborations_5c56c15f: {
    message: "Samarbeten"
  },
  copyright_holder_66ee111: {
    message: "Upphovsr\xE4ttshavare:"
  },
  course_navigation_dd035109: {
    message: "Kursnavigering"
  },
  creative_commons_license_725584ae: {
    message: "Gemensam kreativitet licens:"
  },
  decorative_image_fde98579: {
    message: "Dekorativ-bild"
  },
  discussions_a5f96392: {
    message: "Diskussioner"
  },
  discussions_index_6c36ced: {
    message: "Diskussionindex"
  },
  embed_image_1080badc: {
    message: "B\xE4dda in bild"
  },
  enter_search_terms_e397b1f0: {
    message: "uppge s\xF6ktermer"
  },
  enter_the_alternative_text_for_this_image_88047c47: {
    message: "Ange alternativ text f\xF6r den h\xE4r bilden"
  },
  file_upload_form_4aaad554: {
    message: "Fil uppladdningsformul\xE4r"
  },
  files_c300e900: {
    message: "Filer"
  },
  files_index_af7c662b: {
    message: "Filindex"
  },
  folder_705fd2d7: {
    message: "Mapp"
  },
  font_size_press_down_to_select_6c25dc2d: {
    message: "Typsnittsstorlek, trycker ner f\xF6r att v\xE4lja"
  },
  formatting_press_down_to_select_df728c30: {
    message: "Formatering, tryck ner f\xF6r att v\xE4lja"
  },
  grades_a61eba0a: {
    message: "Bed\xF6mningar"
  },
  group_navigation_99f191a: {
    message: "Gruppnavigering"
  },
  i_have_obtained_permission_to_use_this_file_6386f087: {
    message: "Jag har f\xE5tt till\xE5telse att anv\xE4nda den h\xE4r filen."
  },
  i_hold_the_copyright_71ee91b1: {
    message: "Jag \xE4r uppr\xE4ttshavare"
  },
  if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5: {
    message: "Om du inte v\xE4ljer anv\xE4ndningsr\xE4ttigheter nu kommer den h\xE4r filen att publiceras efter att den har laddats upp."
  },
  image_upload_form_7b74079a: {
    message: "Bild uppladdningsformul\xE4r"
  },
  images_7ce26570: {
    message: "Bilder"
  },
  insert_equella_links_49a8dacd: {
    message: "F\xF6r in Equella l\xE4nkar"
  },
  insert_link_6dc23cae: {
    message: "Skriv in l\xE4nk"
  },
  insert_math_equation_57c6e767: {
    message: "F\xF6r in en matematisk ekvation"
  },
  link_7262adec: {
    message: "L\xE4nk"
  },
  link_to_a_new_page_6c4ad034: {
    message: "L\xE4nka till en ny sida"
  },
  link_to_other_content_in_the_course_879163b5: {
    message: "L\xE4nka till annat inneh\xE5ll i kursen."
  },
  link_to_other_content_in_the_group_3fe25379: {
    message: "L\xE4nka till annat inneh\xE5ll i gruppen."
  },
  link_to_url_52dd935c: {
    message: "L\xE4nk till URL"
  },
  links_14b70841: {
    message: "L\xE4nkar"
  },
  load_more_results_460f49a9: {
    message: "H\xE4mta fler resultat"
  },
  loading_25990131: {
    message: "Laddar..."
  },
  loading_failed_b3524381: {
    message: "Laddning misslyckades..."
  },
  loading_folders_8d4d5d5a: {
    message: "L\xE4ser in mappar..."
  },
  modules_c4325335: {
    message: "Moduler"
  },
  no_results_940393cf: {
    message: "Inga resultat."
  },
  pages_e5414c2c: {
    message: "Sidor"
  },
  people_b4ebb13c: {
    message: "Personer"
  },
  quizzes_7e598f57: {
    message: "Quizzes"
  },
  record_upload_media_5fdce166: {
    message: "Spela in/ladda upp media"
  },
  rich_text_area_press_alt_f8_for_help_58f0f2c3: {
    message: "Rik text-omr\xE5de. Tryck ALT+F8 f\xF6r hj\xE4lp"
  },
  search_280d00bd: {
    message: "S\xF6k"
  },
  search_flickr_6884b518: {
    message: "S\xF6k Flickr"
  },
  select_a_file_53ba40ac: {
    message: "V\xE4lj en fil"
  },
  select_a_folder_to_upload_your_file_into_b82d12b: {
    message: "V\xE4lj en mapp att ladda upp din fil till"
  },
  syllabus_f191f65b: {
    message: "Kurs\xF6versikt"
  },
  text_color_press_down_to_select_8f5ad9b5: {
    message: "Textf\xE4rg, tryck ner f\xF6r att v\xE4lja"
  },
  the_material_is_in_the_public_domain_279c39a3: {
    message: "Materialet \xE4r i den offentliga dom\xE4nen"
  },
  the_material_is_licensed_under_creative_commons_3242cb5e: {
    message: "Materialet har en licens fr\xE5n Creative Commons"
  },
  the_material_is_subject_to_fair_use_exception_41bc6a4b: {
    message: "Materialet \xE4r f\xF6rem\xE5l f\xF6r r\xE4ttvist anv\xE4ndningsundantag."
  },
  this_upload_exceeds_the_file_storage_quota_please__c3a1b641: {
    message: "Den h\xE4r uppladdningen \xF6verskrider fillagringskvoten. Kontakta din systemadministrat\xF6r."
  },
  upload_8b403d05: {
    message: "Ladda upp"
  },
  upload_a_new_file_96e6d4ff: {
    message: "Ladda upp en ny fil"
  },
  upload_a_new_image_890df275: {
    message: "Ladda upp en ny bild"
  },
  usage_right_ff96f3e2: {
    message: "Anv\xE4ndarr\xE4ttigheter:"
  },
  what_would_you_like_to_call_the_new_page_d7e4488a: {
    message: "Vad vill du kalla den nya sidan?"
  },
  wiki_home_9cd54d0: {
    message: "Wiki hem"
  }
};

_formatMessage.default.addLocale({
  "sv-x-k12": locale
});